import React from "react";
import Header from "../../component/header";
import Footer from "../../component/footer";
import {useNavigate} from "react-router-dom"
import {Input} from "antd-mobile";
import Aftertest from "./aftertest";
import Resource from "./resource";

const tuijianCard = [
    { id: 1, search: '诗人' },
    { id: 2, search: '金樽' },
    { id: 3, search: '浊酒' },
    { id: 4, search: '绿蚁酒' },
    { id: 5, search: '剑南烧春' },
    { id: 6, search: '扶苏' },
    { id: 7, search: '凝露浆' },
    { id: 8, search: '欢伯' }
];

export default function Afterclass (){
    const navigate = useNavigate();

    function goSearch() {
        //跳转搜索界面
        navigate('/search')
    }

    return (
        <div>
            <Header/>
             <div className="page afterclass-page">
                <div className="page-con">
                    <div className="search-kongbai"></div>

                    <div className="search-form">
                        <div className="search-container" onClick={goSearch}>
                            <i className="search-container i"></i>
                            <Input className="search-container input" placeholder="搜索知识卡片"/>
                        </div>
                    </div>

                    <div className="search_tuijian_content">
                        <div className="search_tuijian_title">推荐搜索</div>
                        <div className="search_tuijian_cardContent">
                            {tuijianCard.map(ele => (
                                <div key={ele.id} className="search_tuijian_name">{ele.search}</div>
                            ))}
                        </div>

                    </div>

                    <Aftertest/>

                </div>

                 <Resource/>

                 <Footer/>
            </div>

        </div>
    )

}
